interface Props {
	columnCount: number;
	message?: string;
}

export default function NoDataTableBody(props: Props) {
	return (
		<tbody>
			<tr className="no-data">
				<td colSpan={props.columnCount}>
					{props.message ? props.message : "You have no data available."}
				</td>
			</tr>
		</tbody>
	);
}
